import styled from 'styled-components';
import { Github } from '@styled-icons/boxicons-logos/Github';
import { LinkedinWithCircle } from '@styled-icons/entypo-social/LinkedinWithCircle';

export const Name = styled.h4`
  font-size: 13px;
  color: #fff;
  font-weight: 500;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0px);
`;

export const Git = styled(Github)`
  color: #fe8900;
  height: 17px;
  width: 17px;
  cursor: pointer;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
  position: absolute;
  bottom: 40px;
  left: 49.2%;
  transition: 0.2s all;

  &:hover {
    transform: translateY(-2px) scale(1.15);
  }
`;

export const Ln = styled(LinkedinWithCircle)`
  color: #fe8900;
  height: 17px;
  width: 17px;
  cursor: pointer;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
  position: absolute;
  bottom: 40px;
  left: 50.5%;
  &:hover {
    transform: translateY(-2px) scale(1.15);
  }
`;
